<div class="input">
  <textarea
    matInput
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="4"
    cdkAutosizeMaxRows="10"
    [value]="value.detail"
    (input)="onTextChange($event)"
  ></textarea>
  <div (click)="!loading ? picker.click() : null" class="img"></div>
  <div #picker class="picker">
    <ng-container *ngIf="value.image?.length < 5">
      <label for="file-input">
        <img
          src="../../../../../assets/images/workorder/upload.webp"
          width="70"
          height="70"
          alt=""
        />
      </label>
      <input
        type="file"
        id="file-input"
        accept="image/png,image/jpeg"
        style="opacity: 0; width: 1px"
        (change)="onFileChange($event)"
      />
    </ng-container>
  </div>
</div>
<div class="shows">
  <div #picker class="picker">
    <ng-container *ngIf="value.image?.length !== 0">
      <div class="detail" *ngFor="let item of value.image">
        <app-image
          [fileid]="item"
          width="100px"
          height="100px"
          (click)="preview(item)"
        >
        </app-image>
        <mat-icon (click)="clear(item)">close</mat-icon>
      </div>
    </ng-container>
  </div>
</div>
